'use strict';
import {
    debounce,
    isPhablet
} from '../../../_js/_helper';
import ellipsis from '../../../vendors/ellipsis';
import moment from 'moment';
import objectFitImages from 'object-fit-images';
import 'jqueryMatchHeight';

export default class ListingPage {
    constructor() {
        let that = this;
        let isMobileDevice = isPhablet();

        let matchListingHeight = function (sel) {
            sel.matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        };

        //making listing take data from json file
        function populateListing($api, $baseurl, $viewmore, $listingtype, $newslistingItem) {
            console.log('hey listing')
            var $html = '';
            $viewmore.hide();

            // Get the start and amount of elements to capture from the view-more button
            var $startOfRecord = $viewmore.data('start_of_record') ? $viewmore.data('start_of_record') : 0;
            var $limit = $viewmore.data('limit') ? $viewmore.data('limit') : 6;

            // Add start of file and limit to api query
            // Check if the URL has query parameters already
            var $stringConnector = $api.indexOf('?') > -1 ? '&' : '?';
            // Add the limit and start of record parameters to the API
            $api = $api + $stringConnector + '$skip=' + $startOfRecord + '&$top=' + $limit;
            
            $.ajax({
                url: $api
            }).done(function ($data) {

                //formatting the date before display
                function getFormatedDate(date, time, type, off) {
                    var d = date.getUTCDate(),
                        m = date.getUTCMonth(),
                        y = date.getUTCFullYear(),
                        t = date.getUTCHours(),
                        i = date.getUTCMinutes();

                    if (off) {
                        d += 1;
                    }

                    var ampm = t >= 12 ? 'pm' : 'am';

                    t = t % 12;
                    t = t ? t : 12;
                    i = i < 10 ? '0' + i : i;

                    var strTime = `${t}:${i}${ampm}`,
                        $monthnames = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'),
                        $formatDate;

                    if (time) {
                        $formatDate = (d + ' ' + $monthnames[m] + ' ' + y + ' ' + strTime);
                        // if you need month name
                    } else if (!time && type === 'name') {
                        $formatDate = (d + ' ' + $monthnames[m] + ' ' + y);
                        // if you need month number
                    } else if (!time && type === 'num') {
                        m += 1;
                        if (m.toString().length === 1) {
                            m = '0' + m;
                        }
                        if (d.toString().length === 1) {
                            d = '0' + d;
                        }
                        $formatDate = `${y}/${m}/${d}`;
                    }
                    return $formatDate;

                }

                var $itemtotalcount = 1;

                $.each($data.value, function (index, value) {
                    $itemtotalcount += 1;
                    var $UrlName = this.UrlName,
                        $Title = this.Title,
                        $Summary = this.Summary,
                        $listingWrapper;

                    if (this.TeaserImage != null) {
                        var $ImgUrl = this.TeaserImage.Url,
                            $AlternativeText = this.TeaserImage.AlternativeText;
                    }

                    if ($listingtype === 'news') {
                        $listingWrapper = $newslistingItem.find('.card-listing');
                        var $rawDate = new Date(this.NewsDate),
                            $formatPd,
                            $formatPd = getFormatedDate($rawDate, false, 'num', true);
                    } else if ($listingtype === 'offer') {
                        $listingWrapper = $('#offerslisting .card-listing');
                        var $storeName;
                        this.StoreOffer === null ? $storeName = '' : $storeName = this.StoreOffer.StoreName;
                    } else if ($listingtype === 'event') {
                        $listingWrapper = $('#eventslisting .card-listing');
                        var $startDate = new Date(this.EventStart),
                            $endDate = new Date(this.EventEnd),
                            $formatPd,
                            sameDay = false;

                        if (!this.AllDayEvent) {
                            if (moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D') === moment($endDate).utcOffset(Math.floor(this.EventEndUtcOffset / 60)).format('D')) {
                                sameDay = true;
                            }
                        } else if (this.AllDayEvent) {
                            if (moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D') === moment($endDate).utcOffset(Math.floor(this.EventEndUtcOffset / 60)).subtract(1, 'days').format('D')) {
                                sameDay = true;
                            }
                        }

                        $formatPd = getFormatedDate($startDate, false, 'num', false);
                    } else if ($listingtype === 'retail') {
                        $listingWrapper = $('#retaillisting .card-listing');
                        $Title = this.StoreName;
                        var $ImgUrl = this.StoreLogo.Url,
                            $AlternativeText = this.StoreLogo.AlternativeText;
                    }
                    $html = `
                      <div class="listing-horizontal-card-wrapper container">
                        <div class="listing-horizontal-card js-listing-card">
                        ${$listingtype == 'offer' ? `<a href="${$baseurl}/${$UrlName}">` : ''}
                        ${$listingtype == 'news' ? `<a href="${$baseurl}/${getFormatedDate(new Date(this.PublicationDate), false, 'num')}/${$UrlName}">` : ''}
                        ${$listingtype == 'event' ? `<a href="${$baseurl}/${$formatPd}/default-calendar/${$UrlName}">` : ''}
                        ${$listingtype == 'retail' ? `<a href="${$baseurl}/${this.Parent.UrlName}/${$UrlName}">` : ''}
                            <div class="listing-horizontal-card-image-wrapper">${$ImgUrl ? `<img src="${$ImgUrl}" alt="${$AlternativeText}" class="tiles-content-card-img">` : ''}</div>
                            <div class="listing-horizontal-card-text">
                              <div class="listing-horizontal-card-heading-wrapper">
                                <p class="listing-horizontal-card-heading">${$Title}</p>
                              </div>
                              ${$listingtype == 'offer' && this.StoreOffer != null ? `<span class="listing-horizontal-card-subheading">${$storeName}</span>` : '<span class="listing-horizontal-card-subheading"></span>'}
                              ${$listingtype == 'event' && !this.AllDayEvent && !sameDay ? `<span class="listing-horizontal-card-subheading">${moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D MMM YYYY h:mm a')} - ${moment($endDate).utcOffset(Math.floor(this.EventEndUtcOffset / 60)).format('D MMM YYYY h:mm a')}</span>` : ''}
                              ${$listingtype == 'event' && this.AllDayEvent && !sameDay ? `<span class="listing-horizontal-card-subheading">${moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D MMM YYYY')} - ${moment($endDate).utcOffset(Math.floor(this.EventEndUtcOffset / 60)).subtract(1, 'days').format('D MMM YYYY')}</span>` : ''}
                              ${$listingtype == 'event' && this.AllDayEvent && sameDay ? `<span class="listing-horizontal-card-subheading">${moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D MMM YYYY')}</span>` : ''}
                              ${$listingtype == 'event' && !this.AllDayEvent && sameDay ? `<span class="listing-horizontal-card-subheading">${moment($startDate).utcOffset(Math.floor(this.EventStartUtcOffset / 60)).format('D MMM YYYY h:mm a')} - ${moment($endDate).utcOffset(Math.floor(this.EventEndUtcOffset / 60)).format('h:mm a')}</span>` : ''}
                              ${$Summary != undefined ? `<p class="listing-horizontal-card-body">${$Summary}</p>` : ''}
                              ${$listingtype == 'news' && this.HideDate != true ? `<p class="listing-horizontal-card-type"><span class="listing-horizontal-card-date">${getFormatedDate($rawDate, false, 'name', true)}</span></p>` : ''}
                              ${$listingtype == 'retail' ? `<span id="level" class="listing-horizontal-card-subheading">${this.Parent.FloorName}</span>` : ''}
                              ${$listingtype == 'retail' ? `</span><span id="phone" class="listing-horizontal-card-subheading">${this.StorePhone}</span>` : ''}
                            </div>
                          </a>
                        </div>
                      </div>
                    `;

                    $listingWrapper.append($html);
                    $('.listing-horizontal-card-body').toArray().forEach((text) => {
                        if ($(text).text().length > 147) {
                            $(text).ellipsis({
                                lines: 3,
                                ellipClass: 'ellip',
                                responsive: true
                            });
                        }
                    });

                    matchListingHeight($('.listing-horizontal-card-heading-wrapper'));
                });

                // If there is more than 6 records AND
                // If number of records being showed is less than total count
                // show button
                if (($startOfRecord + $limit) < $itemtotalcount) {
                    $viewmore.show();
                }

                // Increment the data attributes for start of record
                $startOfRecord = $startOfRecord + $limit;
                $viewmore.data('start_of_record', $startOfRecord);

                objectFitImages('img.tiles-content-card-img');

            }).fail(function (error) {
                console.log(error)
                console.log('Error: ' + error);
            });
        }

        if ($('.listing-horizontal-card-heading-wrapper').length) {

            matchListingHeight($('.listing-horizontal-card-heading-wrapper'));

            // Window Listener
            that.$window = $(window);
            that.$window.on('resize orientationchange', debounce(function () {
                isMobileDevice = isPhablet();
                if (!isMobileDevice) {
                    matchListingHeight($('.listing-horizontal-card-heading-wrapper'));
                }
            }, 250));
        }

        try {
            //load populateListing function on load
            $('.newslisting').each(function() {
                populateListing(
                    $(this).data('listingapiurl'),
                    $(this).data('detailbaseurl'),
                    $(this).find('.link-wrapper'),
                    'news',
                    $(this)
                );
            })

            if ($('#offerslisting').length > 0) {
                populateListing(
                    $('#offerslisting').data('listingapiurl'),
                    $('#offerslisting').data('detailbaseurl'),
                    $('#offerslisting .link-wrapper'),
                    'offer'
                );
            }

            if ($('#eventslisting').length > 0) {
                populateListing(
                    $('#eventslisting').data('listingapiurl'),
                    $('#eventslisting').data('detailbaseurl'),
                    $('#eventslisting .link-wrapper'),
                    'event'
                );
            }

            if ($('#retaillisting').length > 0) {
                populateListing(
                    $('#retaillisting').data('listingapiurl'),
                    $('#retaillisting').data('detailbaseurl'),
                    $('#retaillisting .link-wrapper'),
                    'retail'
                );
            }
        } catch (ex) {}


        $('.view-more-listing').on('click touchstart', function (e) {
            var target = $(e.target).parents('.js-card-listing-wrapper');

            e.preventDefault();
            $('.newslisting').each(function() {
                populateListing(
                    $(this).data('listingapiurl'),
                    $(this).data('detailbaseurl'),
                    $(this).find('.link-wrapper'),
                    'news',
                    $(this)
                );
            })

            if ($('#offerslisting').length > 0 && target.is('#offerslisting')) {
                populateListing(
                    $('#offerslisting').data('listingapiurl'),
                    $('#offerslisting').data('detailbaseurl'),
                    $('#offerslisting .link-wrapper'),
                    'offer'
                );
            }

            if ($('#eventslisting').length > 0 && target.is('#eventslisting')) {
                populateListing(
                    $('#eventslisting').data('listingapiurl'),
                    $('#eventslisting').data('detailbaseurl'),
                    $('#eventslisting .link-wrapper'),
                    'event'
                );
            }

            if ($('#retaillisting').length > 0 && target.is('#retaillisting')) {
                populateListing(
                    $('#retaillisting').data('listingapiurl'),
                    $('#retaillisting').data('detailbaseurl'),
                    $('#retaillisting .link-wrapper'),
                    'retail'
                );
            }
        });
    }
}
